import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Table, Modal, Form } from 'react-bootstrap';

import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import $ from 'jquery';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';

import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';

import PrintView from './PrintView';
import TransactionComment from './TransactionComment';

function ShowPrintPreview(props) {
    const sid = sessionStorage.getItem('sessionId');
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    // const [entityType, setEntityType] = useState(sessionStorage.entityType);
    const entityType = sessionStorage.entityType;

    const [onceRun, setOnceRun] = useState(false);
    const [reqData, setReqData] = useState([]);
    const [logListData, setLogListData] = useState([]);
    const [docListData, setDocListData] = useState([]);
    const [payListData, setPayListData] = useState([]);

    const [coverListData, setCoverListData] = useState([]);
    //const [rightCoverrate, setRightCoverrate] = useState([]);
    const [rightUnlockTransaction, setRightUnlockTransaction] = useState([]);
    const [rightA2Form, setRightA2Form] = useState([]);
    const [rightA2FormFilled, setRightA2FormFilled] = useState([]);

    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);
    const [showUnlockTran, setShowUnlockTran] = useState(false);
    const [remark, setRemark] = useState("");

    const [rightBmaprove, setRightBmaprove] = useState([]);
    const [rightZmaprove, setRightZmaprove] = useState([]);
    const [rightBhaprove, setRightBhaprove] = useState([]);

    const [reqBmApproved, setReqBmApproved] = useState(0);
    const [reqZmApproved, setReqZmApproved] = useState(0);
    const [reqBhApproved, setReqBhApproved] = useState(0);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                let resp1 = JSON.parse(result1);
                setReqData(resp1);
                setLogListData(resp1.req_activitylog);
                setDocListData(resp1.req_documentdetail);
                setPayListData(resp1.req_paymentdetail);
                setReqBmApproved(resp1.req_bmapproval);
                setReqZmApproved(resp1.req_zmapproval);
                setReqBhApproved(resp1.req_bhapproval);
            });
            /*Common.callApi(Common.apiRight, [sid, 'all', 'COVERRATE'], function (result1) {
                setRightCoverrate(JSON.parse(result1));
            });*/
            Common.callApi(Common.apiRight, [sid, 'all', 'UNLOCKTRANSACTION'], function (result1) {
                setRightUnlockTransaction(JSON.parse(result1));
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'BMAPROVE'], function (result3) {
                setRightBmaprove(JSON.parse(result3));
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'ZMAPROVE'], function (result3) {
                setRightZmaprove(JSON.parse(result3));
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'BHAPROVE'], function (result3) {
                setRightBhaprove(JSON.parse(result3));
            });
            /*Common.callApi(Common.apiRight, [sid, 'all', 'A2FORM'], function (result3) {
                setRightA2Form(JSON.parse(result3));
            });*/

            Common.callApi(Common.apiRight, [sid, 'all', 'A2FORMFILLED'], function (result3) {
                setRightA2FormFilled(JSON.parse(result3));
            });

            Common.callApi(Common.apiCover, [sid, 'listjson', props.srno], function (result) {
                setCoverListData(JSON.parse(result));
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, props]);

    function btnBackClick() {
        props.callInProgress();
    }

    function btnDocumentView(srno, filename) {
        $('.loader').show();
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function btnUnlockTransaction() {
        var object1 = {
            srno: props.srno
        }
        Common.callApi(Common.apiCover, [sid, 'unlocktransaction', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);

            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function btnLockTransaction() {
        let check = window.confirm("Are you sure you want to lock this transaction?");
        if (!check) return false;
        var object1 = {
            srno: props.srno
        }
        Common.callApi(Common.apiCover, [sid, 'locktransaction', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setMsgText(resp.message);
            setMsgBox(true);

        });
    }

    function handleShowUnlockTran() {
        setShowUnlockTran(!showUnlockTran);
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiPaymentApprove, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function btnBmApprove() {
        if (window.confirm('Are you sure to Approve the Transaction ? Transaction once approved will be processed.')) {
            Common.callApi(Common.apiComplianceApprove, [sid, 'BMAPROVE', props.srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setReqBmApproved(1);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }

            });
        }
    }
    function btnZmApprove() {
        if (window.confirm('Are you sure to Approve the Transaction ? Transaction once approved will be processed.')) {
            Common.callApi(Common.apiComplianceApprove, [sid, 'ZMAPROVE', props.srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setReqZmApproved(1);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }

            });
        }
    }
    function btnBhApprove() {
        if (window.confirm('Are you sure to Approve the Transaction ? Transaction once approved will be processed.')) {
            Common.callApi(Common.apiComplianceApprove, [sid, 'BHAPROVE', props.srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setReqBhApproved(1);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }

            });
        }
    }

    function btnA2Form() {
        //alert('hi');
        window.open("a2/" + props.srno, "_blank");
    }

    function btnA2FormV1() {
        window.open("a2v1/F/" + props.srno, "_blank");
    }

    const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };
    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                    </Col>
                    <Col>
                        {
                            rightBmaprove.query === "1" && reqBmApproved === "0" && reqData.req_adddetailsfinal === "1" ?
                                <>
                                    <Button variant="outline-danger" size="sm" onClick={(e) => btnBmApprove()} >BM Approval</Button>&nbsp;
                                </> : null
                        }
                        {
                            rightZmaprove.query === "1" && reqZmApproved === "0" && reqData.req_adddetailsfinal === "1" ?
                                <>
                                    <Button variant="outline-danger" size="sm" onClick={(e) => btnZmApprove()} >ZM Approval</Button>&nbsp;
                                </> : null
                        }
                        {
                            rightBhaprove.query === "1" && reqBhApproved === "0" && reqData.req_adddetailsfinal === "1" ?
                                <>
                                    <Button variant="outline-danger" size="sm" onClick={(e) => btnBhApprove()} >BH Approval</Button>&nbsp;
                                </> : null
                        }
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <PrintView rhdata={reqData}></PrintView>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <h5>Documents</h5>
                    </Col>
                </Row>
                <Row>
                    <Col>

                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>

                                    <td>Type</td>
                                    <td>Remark</td>
                                    <td>File Name</td>
                                     <td>Upload Timestamp</td>
                                    <td>&nbsp;</td>
                                </tr>
                            </thead>
                            <tbody>
                                {docListData.map((res) =>
                                    <tr key={res.doc_filename}>

                                        <td className='divHide'>{res.doc_srno}</td>
                                        <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                        <td>{res.doc_remark}</td>
                                        <td>{res.doc_aws == 1 ? res.doc_aws_path : res.doc_filename}</td>
                                         <td>{res.doc_uploadedat}</td>
                                        <td>
                                            <div className="colorThemeBlue">
                                                {
                                                    (res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                        || res.doc_ext === "jpg" || res.doc_ext === "png")) ?
                                                        <>
                                                            <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>&nbsp;
                                                        </> : null
                                                }

                                                {(res.doc_aws == 1 &&
                                                    (
                                                        res.doc_ext === "pdf" ||
                                                        res.doc_ext === "jpeg" ||
                                                        res.doc_ext === "gif" ||
                                                        res.doc_ext === "jpg" ||
                                                        res.doc_ext === "png" ||
                                                        res.doc_ext === "webp"
                                                    )) && (
                                                        <span className="handCursor" onClick={(e) => Common.viewUploadedDocument(res.doc_aws_path, sid, openDocument)}>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    )}
                                                &nbsp;&nbsp;
                                                {res.doc_aws == 1 ? (
                                                    <span className="handCursor" onClick={(e) => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                        <FontAwesomeIcon icon={faFileDownload} />
                                                    </span>
                                                ) :
                                                    <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faFileDownload} />
                                                    </span>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h5>Payment</h5>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <td>Bank</td>
                                    <td>Reference No</td>
                                    <td>Amount</td>
                                    <td>Date</td>
                                </tr>
                            </thead>
                            <tbody>
                                {payListData.map((res) =>
                                    <tr key={res.srno}>
                                        <td className='divHide'>{res.srno}</td>
                                        <td>{res.bank + ' : ' + res.banknm}</td>
                                        <td>{res.refno}</td>
                                        <td>{res.amnt}</td>
                                        <td>{(res.paydate).split('-').reverse().join('/')}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>

                {
                    (entityType === "B") ?
                        <>
                            <Row>
                                <Col>
                                    <h5>Cover Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                <td className='divHide'></td>
                                                <td>Cover Bank</td>
                                                <td>Cover Quantity</td>
                                                <td>Cover Rate</td>
                                                <td>Deal Number</td>
                                                <td>Expiry Date</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {coverListData.map((res) =>
                                                <tr key={res.srno}>
                                                    <td className='divHide'>{res.srno}</td>
                                                    <td>{res.bank + ' : ' + res.banknm}</td>
                                                    <td>{res.cvalue}</td>
                                                    <td>{res.rate}</td>
                                                    <td>{res.deal}</td>
                                                    <td>{(res.vdate).split('-').reverse().join('/')}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                        : null
                }
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                {
                    sessionStorage.entityType == "B" ?
                        <>
                            <Row>
                                <Col>
                                    <TransactionComment srno={props.srno} rc={refreshCounter}></TransactionComment>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h5>Activity Log</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                <td>Time Stamp</td>
                                                <td>User Name</td>
                                                <td>Remark</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {logListData.map((res) =>
                                                <tr key={res.reqlog_rndnum}>
                                                    <td>{res.reqlog_logtime}</td>
                                                    <td>{res.um_username}</td>
                                                    <td>{res.reqlog_rmk}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>

                                </Col>
                            </Row>
                            <Row>
                                &nbsp;
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Form.Group >
                                        <Form.Label>Comment</Form.Label>
                                        <Form.Control type="text" placeholder="Comment" maxLength={100}
                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setRemark)}
                                            value={remark} autoComplete="off" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                &nbsp;
                            </Row>
                        </> : null
                }

                <Row>
                    <Col>
                        <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        {
                            /*
                                rightA2Form.query === "1" ? <>
                                    <Button variant="outline-success" size="sm" onClick={(e) => btnA2Form()} >A2 Form</Button>&nbsp;
                                    <Button variant="outline-success" size="sm" onClick={(e) => btnA2FormV1()} >A2 Form V1</Button>&nbsp;
                                </> : null
                            */
                        }

                        {
                            rightA2FormFilled.query === "1" ? <>
                                <Button variant="outline-success" size="sm" onClick={(e) => btnA2FormV1()} >A2 Form </Button>&nbsp;
                            </> : null
                        }
                        <span>&nbsp;</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;

                        {
                            rightUnlockTransaction.query === "1" ?
                                <>
                                    <input type="checkbox"
                                        checked={showUnlockTran}
                                        onChange={handleShowUnlockTran}
                                    />&nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        showUnlockTran ?
                                            <>
                                                <Button variant="outline-danger" size="sm" onClick={(e) => btnUnlockTransaction()} >Unlock Transaction</Button>&nbsp;
                                                {
                                                    sessionStorage.getItem('userSrno') == '1' &&
                                                    <Button variant="outline-danger" size="sm" onClick={(e) => btnLockTransaction()} >Lock Transaction</Button>
                                                }
                                            </>
                                            : null
                                    }
                                </>
                                :
                                null
                        }
                    </Col>
                </Row>
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                    {
                        /*
                        type="image/png" type="application/pdf"
                        width="100%" height="100%"
                        
                        <object data={documentToView} type={documentTypeToView} class="internal">
     
                        </object>
                        */
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
export default ShowPrintPreview;